import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepositoryImageComponent } from './repository-image.component';
import { UploadImageComponent } from './upload-image/upload-image.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { FilePickerModule } from 'ngx-awesome-uploader';
import { DirectoryImageComponent } from './directory-image/directory-image.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContextMenuComponent } from './directory-image/context-menu/context-menu.component';




@NgModule({
  declarations: [
    RepositoryImageComponent,
    UploadImageComponent,
    DirectoryImageComponent,
    ContextMenuComponent
  ],
  imports: [
    CommonModule,
    NgxDropzoneModule,
    FilePickerModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports:[
    RepositoryImageComponent,
    UploadImageComponent
  ]
})
export class RepositoryImageModule { }
